import { QueovalBase, InfoBo } from '../global';
import { Person, Corporation, ActionCoHistory } from './action-co.model';

export class ActionCoDetailModel extends QueovalBase 
{

  public BusinessObject: InfoBo;
  public IdCollabo: string;
  public NameCollabo: string;
  public Collaborateurs: Array<Person>;
  public LogoCollabo: string;

  public Customer: Corporation;

  public IdContact: string;
  public NameContact: string;
  public Contacts: Array<Person>;

  public History: Array<ActionCoHistory>;
  constructor() {
    super();

    this.IdCollabo = '';
    this.NameCollabo = '';
    this.Collaborateurs = new Array<Person>();

    this.LogoCollabo = '';

    this.Customer = new Corporation();

    this.IdContact = '';
    this.NameContact = '';
    this.Contacts = new Array<Person>();
    this.History = new Array<ActionCoHistory>();
  }
}
